@if (!auth.initialized()) {
  <div class="text-center mt-5">
    <span class="spinner-border"></span>
    <p>Checking authentication...</p>
  </div>
} @else {
  <app-header />
  <router-outlet />
  <app-footer />
}
